"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var models_1 = require("./models");
exports.getInitialValue = function (metricValues) {
    if (metricValues && metricValues.length) {
        return metricValues[metricValues.length - 1];
    }
    else {
        return undefined;
    }
};
exports.calculateComparison = function (table, currentValue) {
    if (currentValue === undefined) {
        return undefined;
    }
    var idx = table
        .findIndex(function (value) { return value.timestamp.valueOf() === currentValue.timestamp.valueOf() && value.measure === currentValue.measure; });
    if (idx <= 0) {
        return undefined;
    }
    var comparedPoint = table[idx - 1];
    var previous = comparedPoint.measure;
    var absolute = currentValue.measure - previous;
    var percentage = absolute === 0 ? 0 : (absolute / previous);
    return {
        absolute: absolute,
        percentage: percentage,
        comparedPoint: comparedPoint,
    };
};
exports.generatePillValues = function (roles, table, currentValue) {
    var value = currentValue || exports.getInitialValue(table);
    var comparison = table && value ? exports.calculateComparison(table, value) : undefined;
    return mapRolesToValues(roles, value ? value.measure : 0, comparison);
};
var mapRolesToValues = function (roles, value, comparison) {
    return roles
        .map(function (role) {
        switch (role) {
            case models_1.MetricValueRole.CURRENT:
                return { role: role, value: value };
            case models_1.MetricValueRole.ABSOLUTE_CHANGE:
                return comparison ? { role: role, value: comparison.absolute } : undefined;
            case models_1.MetricValueRole.PERCENTAGE_CHANGE:
                return comparison ? { role: role, value: comparison.percentage } : undefined;
            default: return undefined;
        }
    })
        .filter(function (element) { return element !== undefined; });
};
exports.parseDateTrunc = function (qualifiedName) {
    // Qualified names look like this:
    // [dataengine.42019.618651678240].[tyr:Order Date:qk]
    // For Date Trunc fields, the `tyr` there is what we're looking for.
    // Take a look at http://l/datetruncs for more info.
    var regex = /\.\[(.{3,4})\:/;
    // That is:
    // \. a literal period
    // \[ a literal open square brace
    // (.{3,4}) capture 3 or 4 characters
    // \: a literal colon
    var match = regex.exec(qualifiedName);
    if (match) {
        switch (match[1]) {
            case 'tyr':
                return models_1.DateTrunc.YEAR;
            case 'tqr':
                return models_1.DateTrunc.QUARTER;
            case 'tmn':
                return models_1.DateTrunc.MONTH;
            case 'tdy':
                return models_1.DateTrunc.DAY;
            case 'thr':
                return models_1.DateTrunc.HOUR;
            case 'tmi':
                return models_1.DateTrunc.MINUTE;
            case 'tsc':
                return models_1.DateTrunc.SECOND;
            case 'twk':
                return models_1.DateTrunc.WEEK;
            case 'tiyr':
                return models_1.DateTrunc.ISO_YEAR;
            case 'tiqr':
                return models_1.DateTrunc.ISO_QTR;
            case 'tiwk':
                return models_1.DateTrunc.ISO_WEEK;
            case 'tiwd':
                return models_1.DateTrunc.ISO_WEEKDAY;
            default: return models_1.DateTrunc.UNKNOWN;
        }
    }
    return models_1.DateTrunc.UNKNOWN;
};
exports.getDateRange = function (table) {
    if (table.length === 0) {
        return undefined;
    }
    var firstPoint = table[0];
    var lastPoint = table[table.length - 1];
    return {
        first: firstPoint.timestamp,
        last: lastPoint.timestamp,
    };
};
exports.getComparisonDateRange = function (line) {
    if (line.length === 0) {
        return undefined;
    }
    var firstPoint = line[0];
    var lastPoint = line[line.length - 1];
    if (!firstPoint.comparisonTimestamp || !lastPoint.comparisonTimestamp) {
        return undefined;
    }
    return {
        first: firstPoint.comparisonTimestamp,
        last: lastPoint.comparisonTimestamp,
    };
};
exports.dateBefore = function (date, amount, unit) {
    return moment.utc(date).subtract(amount, unit).toDate();
};
exports.dateAfter = function (date, amount, unit) {
    return moment.utc(date).add(amount, unit).toDate();
};
exports.withinRange = function (range, date) { return date >= range.first && date <= range.last; };
//# sourceMappingURL=engine.js.map